import { KnxChapterItem } from "./KnxChapterItem";
import Channel from "../../models/Channel";
import Logger from "../../Logger";
import type KnxContext from "./KnxContext";

import { GlobalScriptDeviceWrapper, GlobalScriptOnline } from "../../KnxGlobalScriptEngine";
import { ValueLevels } from "../../models/KnxInstanceData";

type KnxButtonProps = {
  knxContext: KnxContext;
  parentChannel: Channel;
  xchannels: Array<Channel>;
  title: string;
  data: any;
  args: any;
  repeatindex?: number;
  params: any;
  instanceId: string;
  moduleId: string;
  chapterId: string;
  parentKnxChapter: KnxChapterItem | undefined;
  nestedName: string;
  nestedText: string;
  indent: number;
  hidden: boolean;
  propertyList?: Array<any>;
};

const logger = new Logger();

export default function KnxButton(props: KnxButtonProps) {
  const { knxContext, data, instanceId, parentKnxChapter, moduleId } = props;

  // <Button Id="M-0008_A-C031-22-B9C9-O000A_B-25" Name="GroupsAllSelect" Text="All" Cell="3,2" Icon="" EventHandler="S1_ButtonHandler_GroupsAllSelect" />

  const text = knxContext.getText(data);

  const res = (
    <button
      className="knxButton button"
      style={{ width: data.a.Cell ? "100%" : undefined }}
      title={text}
      onClick={() => {
        try {
          const args = [
            new GlobalScriptDeviceWrapper(knxContext.device, instanceId, ValueLevels.interactive), // device,
            new GlobalScriptOnline(),
            undefined, // progress,
            {}, // context
          ];

          knxContext.knxProductData.knxScriptEngine?.call(data.a.EventHandler, args, {});
        } catch (ex) {
          logger.error("Error calling button event handler", ex);
        }
      }}
    >
      {text}
    </button>
  );

  const currentTable = knxContext.currentTable;
  if (currentTable) {
    const cell = data.a.Cell;
    if (cell) {
      const ii = cell.split(",");

      if (!currentTable.cells[ii[0]]) {
        currentTable.cells[ii[0]] = [];
      }

      currentTable.cells[ii[0]][ii[1]] = res;

      return undefined;
    }
  }

  return res;
}
